import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch } from 'react-redux';
import { useGetCartProductsQuery, useGetMyProductsQuery } from './features/products/productsApiSlice';
import { useGetCategoriesQuery } from './features/categories/categoriesApiSlice';
import { useGetSubCategoriesQuery } from './features/subCategories/subCategoriesApiSlice';
import { useGetBrandsQuery } from './features/brands/brandsApiSlice';
import { ROUTES } from './assets/data';

import useComponentHeight from "./hooks/useComponentHeight";

import Navbar from "./components/Navbar.jsx";
import Products from "./pages/Products.jsx";
import Login from "./pages/Login.jsx";
import Register from "./pages/Register.jsx";
import Prefetch from "./components/Prefetch.js";
import PersistLogin from "./components/PersistLogin.js";
import AccountSettings from "./pages/AccountSettings.jsx";
import Store from "./pages/Store.jsx";
import Search from "./pages/Search";
import ProductForm from "./pages/ProductForm.jsx";
import ProductDetail from "./pages/ProductDetail.jsx";

import useAuth from "./hooks/useAuth.js";
import { initiateCart, initiateMyInfo } from "./features/users/userSlice.js";
import { loadMyStore } from "./features/products/productSlice";
import { loadCategories } from "./features/categories/categorySlice";
import { loadSubCategories } from "./features/subCategories/subCategorySlice";
import { loadBrands } from "./features/brands/brandSlice";
//import Cart from "./components/Cart.js";

import "react-image-crop/dist/ReactCrop.css";
import { useGetUserByIdQuery } from "./features/users/usersApiSlice";
import CreateProduct from "./pages/CreateProduct";
import './styles/quill.css';
import UpdateProduct from "./pages/UpdateProduct";
import ScrollToTop from "./components/ScrollToTop";
// import { useSelector } from "react-redux";
// import { selectCurrentToken } from "./features/auth/authSlice";

function App() {
  const { id } = useAuth();
  const dispatch = useDispatch();

  // const token = useSelector(selectCurrentToken);
  // if (!token) {
  //   localStorage.setItem('persist', 'false');
  // }

  localStorage.setItem('firstLoad', 1);
  //const { productInCart } = useSelector((state) => state.user);
  const {
    data: cartProducts,
    isSuccess: isCartSuccess,
  } = useGetCartProductsQuery(id);
  const {
    data: myInfo,
    isSuccess: myInfoSuccess
  } = useGetUserByIdQuery(id)
  const {
    data: myProducts,
    isSuccess: storeSuccess,
  } = useGetMyProductsQuery(id);
  
  // Fetch categories, subcategories, and brands
  const {
    data: categories,
    isSuccess: categoriesSuccess,
  } = useGetCategoriesQuery();
  
  const {
    data: subCategories,
    isSuccess: subCategoriesSuccess,
  } = useGetSubCategoriesQuery();
  
  const {
    data: brands,
    isSuccess: brandsSuccess,
  } = useGetBrandsQuery();

  useEffect(() => {
    if (id !== "" && isCartSuccess) {
      dispatch(initiateCart(cartProducts));
    }
    if (id !== "" && storeSuccess) {
      dispatch(loadMyStore(myProducts));
    }
    if (id !== "" && myInfoSuccess) {
      dispatch(initiateMyInfo(myInfo))
    }
    
    // Store categories, subcategories, and brands in Redux
    if (subCategoriesSuccess) {
      console.log('SubCategories data:', subCategories);
      dispatch(loadSubCategories(subCategories));
    }
    if (categoriesSuccess) {
      console.log('Categories data:', categories);
      dispatch(loadCategories(categories));
    }
    
    
    if (brandsSuccess) {
      console.log('Brands data:', brands);
      dispatch(loadBrands(brands));
    }
    
  }, [
    id, isCartSuccess, storeSuccess, dispatch, cartProducts, myProducts, myInfoSuccess, myInfo,
    categories, categoriesSuccess, subCategories, subCategoriesSuccess, brands, brandsSuccess
  ]);
  
  useComponentHeight();
  return (
    <div className="App overflow-x-hidden">
      <Navbar />
      <ScrollToTop />
      <div className="mt-[64px]">
        <Routes>
          <Route path={ROUTES.LOGIN} element={<Login />} />
          <Route path={ROUTES.SIGNUP} element={<Register />} />
          <Route element={<PersistLogin />}>
              <Route path={ROUTES.HOME} element={<Products />} />
            {/* <Route element={<Prefetch />}> */}
              <Route path={ROUTES.EDIT_PROFILE} element={<AccountSettings />} />
              <Route path={ROUTES.MY_STORE} element={<Store useFor="my-store" />} />
              <Route path={ROUTES.CART} element={<Store useFor="cart" />} />
              {/* <Route path={ROUTES.SEARCH} element={<Search />} /> */}
              {/* <Route path="/Sell" element={<ProductForm />} /> */}
              <Route path={ROUTES.SELL} element={<CreateProduct />} />
              <Route path={`${ROUTES.EDIT_PRODUCT}/:id`} element={<UpdateProduct />}/>
              {/* <Route path="/editProduct/:id" element={<ProductForm />}/> */}
              <Route path={`${ROUTES.MY_PRODUCT_DETAIL}/:id`} element={<ProductDetail useFor="myProductDetail" />}/>
              <Route path={`${ROUTES.CART_PRODUCT_DETAIL}/:id`} element={<ProductDetail useFor="cartProductDetail" />}/>
              <Route path={`${ROUTES.PRODUCT_DETAIL}/:id`} element={<ProductDetail useFor="productDetail" />}/>
            </Route>
          {/* </Route> */}
        </Routes>
      </div>
    </div>
  );
}

export default App;